import {
  isMonthLocked,
  toWireDate,
  withinBackdateWindow,
  type WorklogRules,
} from '@forecastify/shared';
import type { Translate } from '../../i18n';

/**
 * 30 Oct 2026 · why an existing entry on `workedOn` cannot be changed or removed — `null` when it
 * can. The server's own split (`worklog.service.ts`): every UPDATE runs the month lock AND the
 * backdating window (`enforceRules`), a DELETE only the month lock (`requireMonthOpen`). A screen
 * that offered the edit and let the server refuse it was the inconsistency the audit found.
 *
 * ⚠️ `mayOverride` is `worklog.lock`, which lifts the window and never the lock — as on the day view.
 */
export function entryLock(
  t: Translate,
  workedOn: string,
  rules: WorklogRules,
  mayOverride: boolean,
  today: string = toWireDate(new Date()),
): { readonly edit: string | null; readonly remove: string | null } {
  if (isMonthLocked(workedOn, today, rules.lockDay)) {
    const reason = t('time.closed.month');
    return { edit: reason, remove: reason };
  }
  if (!withinBackdateWindow(workedOn, today, rules, mayOverride).ok) {
    return { edit: t('time.closed.backdate', { days: rules.backdateDays }), remove: null };
  }
  return { edit: null, remove: null };
}
